/* eslint-disable import/no-default-export */
import { HeaderTestIds } from '@trello/webdriverio-tests';
import { IconName } from 'app/common/components/controls/icon';
import { Noun, Verb, trackUe } from '@trello/analytics';
import { EnterpriseMenuPopoverId } from 'app/gamma/src/components/popovers/popover-ids';
import { showPopover, State } from 'app/gamma/src/modules';
import React, { lazy, Suspense } from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { isEnterpriseAdmin } from 'app/gamma/src/selectors/enterprises';
import { isPopoverShown } from 'app/gamma/src/selectors/popovers';
import HeaderButton from './button';

const EnterpriseMenuPopoverPromise = import(/* webpackChunkName: "enterprise-menu-popover" */ 'app/gamma/src/components/popovers/enterprise-menu');
const EnterpriseMenuPopover = lazy(() => EnterpriseMenuPopoverPromise);

interface StateProps {
  isActive: boolean;
  isAdmin: boolean;
}

interface DispatchProps {
  onClick: () => void;
}

type AllProps = StateProps & DispatchProps;

class EnterpriseMenuButton extends React.Component<AllProps> {
  menuButtonRef = React.createRef<HTMLButtonElement>();

  render() {
    const { onClick, isActive, isAdmin } = this.props;
    if (!isAdmin) {
      return null;
    }

    return (
      <>
        <HeaderButton
          icon={IconName.Enterprise}
          onClick={onClick}
          ref={this.menuButtonRef}
          testId={HeaderTestIds.EnterpriseDashboardButton}
        />
        {isActive && (
          <Suspense fallback={null}>
            <EnterpriseMenuPopover target={() => this.menuButtonRef.current} />
          </Suspense>
        )}
      </>
    );
  }
}

const mapStateToProps = (state: State): StateProps => ({
  isActive: isPopoverShown(state, EnterpriseMenuPopoverId),
  isAdmin: isEnterpriseAdmin(state),
});

const mapDispatchToProps = (dispatch: Dispatch<State>): DispatchProps => ({
  onClick() {
    trackUe({
      category: Noun.HEADER,
      verb: Verb.OPENS,
      directObj: Noun.ENTERPRISE_DASHBOARD_MENU,
      method: 'by clicking enterprise button in header',
    });
    dispatch(showPopover({ name: EnterpriseMenuPopoverId }));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EnterpriseMenuButton);
